import { render, staticRenderFns } from "./itemcategoryhead.vue?vue&type=template&id=45acd1b0"
import script from "./itemcategoryhead.vue?vue&type=script&lang=js"
export * from "./itemcategoryhead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports